import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import { realParaNumber } from '../../util/numberUtil';
import Moment from 'react-moment';
import selecionarAgendamentoViagem from '../../actions/agendamento-viagem/selecionarAgendamentoViagem';

export class AgendamentoViagem extends Component {

    selecionarAgendamento() {
        this.props.selecionarAgendamentoViagem(this.props.agendamnetoViagem);
        this.props.history.push('/painel-cadastro-agendamento-viagem');
    }

    render() {
        return <div className="geral">
            <div className="resumo">
                <div className="row">
                <div className="col">{this.props.agendamnetoViagem.veiculo.descricao}</div>
                <div className="col"><Moment format="DD/MM/YYYY">{this.props.agendamnetoViagem.dataInicio}</Moment> à <Moment format="DD/MM/YYYY">{this.props.agendamnetoViagem.dataFim}</Moment></div>
                    <div className="col">{this.props.agendamnetoViagem.contratante ? this.props.agendamnetoViagem.contratante.nome : '' }</div>
                    <div className="col">{realParaNumber(this.props.agendamnetoViagem.valorTotal).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</div>
                    
                    <div className="col">{realParaNumber(this.props.agendamnetoViagem.valorUnitario).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</div>
                    
                    <div className="col">{this.props.agendamnetoViagem.quilometragem}</div>

                    <div id='container-botoes' className="col-sm-2 mr-md-n4">
                        <div className='dropdown'>
                            <span className="titulo-mobile">Ações:</span>
                            <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">
                                    &#xe5d4;
                                </i>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div className="botoes">
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <button type="button" className="btn btn-editar " title='Editar Agendamneto'
                                            onClick={() => this.selecionarAgendamento()}>
                                            <i className="material-icons nav-icon">&#xe150;</i>
                                        </button>
                                    </Autorizacao>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <button type="button" className="btn btn-editar " title='Adicionar/Remover passageiros' onClick={() => {
                                            this.props.history.push(`/painel-passageiros-agendamento-viagem?agendamento=${this.props.agendamnetoViagem.id}`);
                                        }}>
                                            <i className="material-icons nav-icon">&#xe637;</i>
                                        </button>
                                    </Autorizacao>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada
    });

export default withRouter(connect(mapStateToProps, 
    {
        selecionarAgendamentoViagem
    })(reduxForm({
    form: 'formularioAgendamentoViagem'
})(AgendamentoViagem)))